import { render, staticRenderFns } from "./RegistrationRequestLayout.vue?vue&type=template&id=97ca9dc8"
import script from "./RegistrationRequestLayout.vue?vue&type=script&lang=ts"
export * from "./RegistrationRequestLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports